<template>
  <v-btn
    @click="authenticate('vsc')"
    block
    color="light-blue"
    dark
    large
  >
    <v-icon
      dark
      left
    >storage</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
import { SOCIAL_AUTH } from '@/graphql.gql';
import { onLogin } from '@/vue-apollo';

export default {
  props: {
    label: String,
  },
  methods: {
    async authenticate(provider) {
      try {
        this.$wait.start('busy');
        await this.$auth.authenticate(provider);
        const response = await this.$apollo.mutate({
          mutation: SOCIAL_AUTH,
          variables: { provider, accessToken: this.$auth.getToken() },
        });
        await onLogin(this.$apollo.provider.defaultClient, response.data.socialAuth.token);
        await this.$store.dispatch('refreshToken');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('Something went wrong. Please, try again.');
      } finally {
        this.$wait.end('busy');
      }
      this.$router.push({ name: 'runs' });
    },
  },
};
</script>
